export default __webpack_public_path__ + "static/media/confirmationImg.87eebe75.svg";